import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import { translate } from 'react-i18next';

import cssVars from '../../styles/_variables';

class HighchartsGraph extends Component {
    static propTypes = {
        config: PropTypes.object.isRequired,
        className: PropTypes.string,
        displayDate: PropTypes.bool,
        t: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.renderGraph();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.config !== this.props.config) {
            this.renderGraph();
        }
    }

    getGraphInstance() {
        return this.instance;
    }

    renderGraph() {
        const { displayDate, t } = this.props;
        const shortMonths = t('shortMonths', { returnObjects: true });

        Highcharts.setOptions({
            lang: {
                decimalPoint: ',',
                months: t('months', { returnObjects: true }),
                weekdays: t('weekdays', { returnObjects: true }),
                shortMonths,
                shortWeekdays: t('shortWeekdays', { returnObjects: true }),
                noData: t('common:noData'),
            },
            global: {
                useUTC: false,
            },
        });

        if (displayDate) {
            this.instance = Highcharts.chart(
                this.container,
                this.props.config,
                (chart) => {
                    const date = new Date(chart.xAxis[0].dataMin);
                    const height = (chart.plotSizeY / 2) + 25;
                    const width = (chart.plotSizeX / 2) - 50;

                    chart.renderer.text(
                        [date.getDate(), shortMonths[date.getMonth()]].join(' '),
                        width,
                        height,
                    ).css({
                        fontSize: '50px',
                        fontWeight: '500',
                        color: '#d2d2d2',
                        textTransform: 'uppercase',
                    }).add();
                }
            );
        } else {
            this.instance = Highcharts.chart(
                this.container,
                this.props.config,
            );
        }
    }

    render() {
        return (
            <div
                className={this.props.className}
                ref={(c) => { this.container = c; }}
            />
        );
    }
}

export default translate('date', { withRef: true })(HighchartsGraph);

export const defaultOptions = {
    colors: [cssVars['color-graph-series-0']],
    chart: {
        backgroundColor: null,
        spacing: [0, 0, 0, 0],
        marginTop: 10,
        marginBottom: 0,
        style: {
            fontFamily: 'inherit',
        },
    },
    title: { style: { display: 'none' } },
    subtitle: { style: { display: 'none' } },
    legend: { enabled: false },
    credits: { enabled: false },
    plotOptions: {
        series: {
            states: {
                hover: {
                    halo: false,
                    lineWidthPlus: 0,
                },
            },
            marker: {
                enabled: false,
            },
        },
    },
    tooltip: {
        animation: false,
        hideDelay: 0,
        followTouchMove: true,
        useHTML: true,
        shape: 'square',
        shared: false,
        crosshairs: true,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
    },
    yAxis: {
        gridLineColor: cssVars['color-main-darker'],
        gridLineWidth: 1,
        title: {
            enabled: false,
        },
        labels: {
            // eslint-disable-next-line
            formatter: function() {
                if (this.isFirst) { return ''; }
                return Highcharts.numberFormat(this.value, 2, ',', ' ');
            },
            style: {
                color: cssVars['color-graph-labels'],
                fontSize: '9px',
            },
        },
    },
    xAxis: {
        gridLineWidth: 0,
        lineWidth: 0,
        tickColor: cssVars['color-border'],
        tickLength: 6,
        offset: 0,
        crosshair: {
            color: cssVars['color-border'],
            width: 1,
        },
        labels: {
            y: -6,
            style: {
                color: cssVars['color-graph-labels'],
                fontSize: '9px',
            },
        },
    },
};



/** WEBPACK FOOTER **
 ** /src/shared/components/graph/HighchartsGraph.js
 **/